import React from "react";

export default function TetFrame2({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".cls-2tet1{fill:#a81a07}.cls-2tet2{fill:#ce3117}.cls-2tet3{fill:#e8c221}.cls-2tet4{fill:#cea90d}"
            }
          </style>
        </defs>
        <path
          d="M1685.08 1821.94H314.92V178.06h1370.16v1643.88Zm-1331.73-38.43h1293.3V216.49H353.35v1567.02Z"
          className="cls-2tet2"
        />
        <path
          d="M1553.31 289.41c-47.96 0-95.91-1.85-143.45-5.56-138.56-10.8-276.46-37.46-409.89-79.25-132.45 40.13-269.18 65.93-406.42 76.69-86.05 6.74-173.46 7.63-259.82 2.64l.81-13.98c85.72 4.96 172.5 4.08 257.91-2.62 136.95-10.73 273.38-36.56 405.51-76.75l2.07-.63 2.07.65c133.07 41.84 270.63 68.52 408.85 79.29 84.28 6.57 169.91 7.28 254.49 2.1l.86 13.97c-37.52 2.3-75.26 3.44-112.98 3.44Z"
          className="cls-2tet2"
        />
        <ellipse
          cx={471.4}
          cy={422.58}
          className="cls-2tet2"
          rx={103.43}
          ry={83.75}
        />
        <path
          d="M367.97 422.58c0-.86.02-1.73.05-2.59-.03.96-.04 1.93-.05 2.9v-.31ZM574.83 422.58c0 45.34-44.5 82.26-100.06 83.7 21.32-16.49 35.66-47.34 35.66-82.68s-15.63-68.9-38.51-84.77c56.89.22 102.91 37.63 102.91 83.74Z"
          className="cls-2tet1"
        />
        <rect
          width={54.22}
          height={15.83}
          x={444.3}
          y={327.33}
          className="cls-2tet3"
          rx={5.29}
          ry={5.29}
        />
        <rect
          width={54.22}
          height={15.83}
          x={444.3}
          y={501.77}
          className="cls-2tet3"
          rx={5.29}
          ry={5.29}
        />
        <path
          d="M456.5 508.08c-.3 0-.61-.05-.91-.15-18.49-6.1-34.2-17.76-45.45-33.73-11.24-15.96-16.91-34.63-16.39-53.99.52-19.02 6.98-37.1 18.7-52.27 11.72-15.18 27.62-26.05 45.96-31.44a2.91 2.91 0 0 1 3.6 1.96c.45 1.54-.43 3.14-1.96 3.6-35.2 10.34-59.51 41.81-60.5 78.32-1 36.74 22.8 70.49 57.86 82.06 1.52.5 2.34 2.14 1.84 3.66a2.89 2.89 0 0 1-2.75 1.99Z"
          className="cls-2tet3"
        />
        <path
          d="M472.43 511.27c-.83 0-1.65-.35-2.22-1.03-11.24-13.36-30.32-41.8-31.86-82.09-1.76-46.17 20.96-79.13 30.81-91.15a2.902 2.902 0 0 1 4.08-.41 2.902 2.902 0 0 1 .41 4.08c-9.43 11.51-31.18 43.07-29.5 87.26 1.47 38.56 19.74 65.78 30.5 78.58 1.03 1.22.87 3.05-.35 4.08-.54.46-1.2.68-1.86.68ZM486.4 508.08a2.89 2.89 0 0 1-2.75-1.99c-.5-1.52.32-3.16 1.84-3.66 35.07-11.57 58.86-45.31 57.86-82.06-.99-36.5-25.3-67.98-60.5-78.32-1.54-.45-2.41-2.06-1.96-3.6s2.06-2.41 3.6-1.96c18.35 5.39 34.24 16.26 45.96 31.44 11.72 15.18 18.18 33.25 18.7 52.27.52 19.36-5.14 38.03-16.39 53.99s-26.97 27.63-45.45 33.73c-.3.1-.61.15-.91.15Z"
          className="cls-2tet3"
        />
        <path
          d="M470.46 511.27c-.66 0-1.32-.22-1.86-.68a2.899 2.899 0 0 1-.35-4.08c10.76-12.79 29.03-40.02 30.5-78.58 1.68-44.19-20.07-75.75-29.5-87.26a2.903 2.903 0 0 1 .41-4.08 2.903 2.903 0 0 1 4.08.41c9.85 12.03 32.56 44.98 30.81 91.15-1.53 40.29-20.62 68.72-31.85 82.09-.57.68-1.39 1.03-2.22 1.03Z"
          className="cls-2tet3"
        />
        <path
          d="M498.51 332.61v5.26c0-2.92-2.37-5.29-5.29-5.29h-43.64c-2.92 0-5.29 2.37-5.29 5.29v-5.26c0-2.92 2.37-5.29 5.29-5.29h43.64c2.92 0 5.29 2.37 5.29 5.29ZM498.51 512.39v-5.26c0 2.92-2.37 5.29-5.29 5.29h-43.64c-2.92 0-5.29-2.37-5.29-5.29v5.26c0 2.92 2.37 5.29 5.29 5.29h43.64c2.92 0 5.29-2.37 5.29-5.29Z"
          className="cls-2tet4"
        />
        <path
          d="M471.4 335.91c-.36 0-.66-.29-.67-.65l-.05-2.67c0-.37.29-.67.65-.68.36 0 .67.29.68.65l.05 2.67c0 .37-.29.67-.65.68h-.01ZM471.23 327.49c-.36 0-.66-.29-.67-.65l-.12-5.75c0-.37.29-.67.65-.68.36-.01.67.29.68.65l.12 5.75c0 .37-.29.67-.65.68h-.01Zm-.24-11.49c-.36 0-.66-.29-.67-.65l-.12-5.75c0-.37.29-.67.65-.68.37 0 .67.29.68.65l.12 5.75c0 .37-.29.67-.65.68h-.01Zm-.24-11.49c-.36 0-.66-.29-.67-.65l-.12-5.75c0-.37.29-.67.65-.68.35-.01.67.29.68.65l.12 5.75c0 .37-.29.67-.65.68h-.01ZM470.52 293.02c-.36 0-.66-.29-.67-.65l-.05-2.67c0-.37.29-.67.66-.68h.01c.36 0 .66.29.67.65l.05 2.67c0 .37-.29.67-.66.68h-.01Z"
          className="cls-2tet3"
        />
        <ellipse
          cx={745.7}
          cy={459.95}
          className="cls-2tet3"
          rx={78.31}
          ry={118.49}
        />
        <path
          d="M667.39 459.95c0-1.22.01-2.45.04-3.66-.02 1.36-.03 2.73-.04 4.1v-.44Z"
          className="cls-2tet1"
        />
        <path
          d="M824.01 459.95c0 64.14-33.69 116.38-75.75 118.42 16.14-23.33 27-66.98 27-116.97s-11.84-97.47-29.15-119.93c43.07.32 77.91 53.24 77.91 118.48Z"
          className="cls-2tet4"
        />
        <rect
          width={41.05}
          height={22.4}
          x={725.18}
          y={325.19}
          className="cls-2tet2"
          rx={5.47}
          ry={5.47}
        />
        <rect
          width={41.05}
          height={22.4}
          x={725.18}
          y={572}
          className="cls-2tet2"
          rx={5.47}
          ry={5.47}
        />
        <path
          d="M734.42 580.93c-.23 0-.46-.07-.69-.21-14-8.63-25.9-25.13-34.41-47.72-8.51-22.58-12.8-48.99-12.4-76.38.39-26.91 5.29-52.49 14.16-73.96 8.87-21.48 20.91-36.86 34.8-44.49 1.16-.64 2.38.61 2.72 2.78.34 2.17-.32 4.45-1.49 5.09-26.65 14.63-45.06 59.15-45.81 110.8-.75 51.98 17.26 99.72 43.81 116.09 1.15.71 1.77 3.03 1.4 5.18-.3 1.72-1.16 2.82-2.08 2.82Z"
          className="cls-2tet2"
        />
        <path
          d="M746.48 585.44c-.63 0-1.25-.5-1.68-1.46-8.51-18.91-22.96-59.13-24.12-116.14-1.33-65.33 15.87-111.95 23.32-128.97.77-1.75 2.15-2.01 3.09-.57.94 1.43 1.07 4.02.31 5.77-7.14 16.29-23.61 60.93-22.33 123.46 1.11 54.56 14.94 93.07 23.09 111.18.78 1.73.66 4.32-.27 5.77-.41.65-.91.96-1.41.96ZM757.05 580.93c-.92 0-1.78-1.09-2.08-2.82-.38-2.15.25-4.47 1.4-5.18 26.55-16.37 44.56-64.11 43.81-116.09-.75-51.65-19.16-96.17-45.81-110.8-1.16-.64-1.83-2.92-1.49-5.09.34-2.17 1.56-3.42 2.72-2.78 13.89 7.62 25.92 23.01 34.8 44.49 8.87 21.47 13.77 47.04 14.16 73.96.4 27.39-3.89 53.81-12.41 76.38-8.52 22.59-20.42 39.09-34.41 47.72-.23.14-.46.21-.69.21Z"
          className="cls-2tet2"
        />
        <path
          d="M744.99 585.44c-.5 0-1-.32-1.41-.96-.93-1.46-1.05-4.04-.27-5.77 8.15-18.1 21.98-56.62 23.09-111.18 1.27-62.52-15.19-107.17-22.33-123.46-.77-1.75-.63-4.33.31-5.77.94-1.43 2.32-1.18 3.09.57 7.46 17.01 24.65 63.64 23.32 128.97-1.16 57-15.61 97.23-24.12 116.14-.43.96-1.05 1.46-1.68 1.46Z"
          className="cls-2tet2"
        />
        <path
          d="M766.22 332.67v7.44c0-4.13-1.79-7.48-4-7.48h-33.04c-2.21 0-4 3.35-4 7.48v-7.44c0-4.13 1.79-7.48 4-7.48h33.04c2.21 0 4 3.35 4 7.48ZM766.23 587.02v-7.44c0 4.13-1.79 7.48-4 7.48h-33.04c-2.21 0-4-3.35-4-7.48v7.44c0 4.13 1.79 7.48 4 7.48h33.04c2.21 0 4-3.35 4-7.48Z"
          className="cls-2tet1"
        />
        <path
          d="M746.04 332.32c-.27 0-.5-.41-.51-.93l-.04-3.78c0-.52.22-.95.5-.97.27-.01.51.4.52.93l.04 3.78c0 .52-.22.95-.5.97h-.01ZM745.91 320.41c-.27 0-.5-.41-.51-.93l-.09-8.13c0-.52.22-.95.5-.97.28-.02.51.4.52.93l.09 8.13c0 .52-.22.95-.5.97h-.01Zm-.18-16.26c-.27 0-.5-.41-.51-.93l-.09-8.13c0-.52.22-.95.5-.97.28-.01.51.4.52.93l.09 8.13c0 .52-.22.95-.5.97h-.01Zm-.18-16.26c-.27 0-.5-.41-.51-.93l-.09-8.13c0-.52.22-.95.5-.97.27-.02.51.4.52.93l.09 8.13c0 .52-.22.95-.5.97h-.01ZM745.37 271.64c-.27 0-.5-.41-.51-.93l-.04-3.78c0-.52.22-.95.5-.97h.01c.27 0 .5.41.51.93l.04 3.78c0 .52-.22.95-.5.97h-.01Z"
          className="cls-2tet1"
        />
        <ellipse
          cx={1254.3}
          cy={459.95}
          className="cls-2tet3"
          rx={78.31}
          ry={118.49}
        />
        <path
          d="M1175.99 459.95c0-1.22.01-2.45.04-3.66-.02 1.36-.03 2.73-.04 4.1v-.44Z"
          className="cls-2tet1"
        />
        <path
          d="M1332.6 459.95c0 64.14-33.69 116.38-75.75 118.42 16.14-23.33 27-66.98 27-116.97s-11.84-97.47-29.15-119.93c43.07.32 77.91 53.24 77.91 118.48Z"
          className="cls-2tet4"
        />
        <rect
          width={41.05}
          height={22.4}
          x={1233.78}
          y={325.19}
          className="cls-2tet2"
          rx={5.47}
          ry={5.47}
        />
        <rect
          width={41.05}
          height={22.4}
          x={1233.78}
          y={572}
          className="cls-2tet2"
          rx={5.47}
          ry={5.47}
        />
        <path
          d="M1243.01 580.93c-.23 0-.46-.07-.69-.21-14-8.63-25.9-25.13-34.41-47.72-8.51-22.58-12.8-48.99-12.4-76.38.39-26.91 5.29-52.49 14.16-73.96 8.87-21.48 20.91-36.86 34.8-44.49 1.16-.64 2.38.61 2.72 2.78.34 2.17-.32 4.45-1.49 5.09-26.65 14.63-45.06 59.15-45.81 110.8-.75 51.98 17.26 99.72 43.81 116.09 1.15.71 1.77 3.03 1.4 5.18-.3 1.72-1.16 2.82-2.08 2.82Z"
          className="cls-2tet2"
        />
        <path
          d="M1255.07 585.44c-.63 0-1.25-.5-1.68-1.46-8.51-18.91-22.96-59.13-24.12-116.14-1.33-65.33 15.87-111.95 23.32-128.97.77-1.75 2.15-2.01 3.09-.57.94 1.43 1.07 4.02.31 5.77-7.14 16.29-23.61 60.93-22.33 123.46 1.11 54.56 14.94 93.07 23.09 111.18.78 1.73.66 4.32-.27 5.77-.41.65-.91.96-1.41.96ZM1265.65 580.93c-.92 0-1.78-1.09-2.08-2.82-.38-2.15.25-4.47 1.4-5.18 26.55-16.37 44.56-64.11 43.81-116.09-.75-51.65-19.16-96.17-45.81-110.8-1.16-.64-1.83-2.92-1.49-5.09.34-2.17 1.56-3.42 2.72-2.78 13.89 7.62 25.92 23.01 34.8 44.49 8.87 21.47 13.77 47.04 14.16 73.96.4 27.39-3.89 53.81-12.41 76.38-8.52 22.59-20.42 39.09-34.41 47.72-.23.14-.46.21-.69.21Z"
          className="cls-2tet2"
        />
        <path
          d="M1253.59 585.44c-.5 0-1-.32-1.41-.96-.93-1.46-1.05-4.04-.27-5.77 8.15-18.1 21.98-56.62 23.09-111.18 1.27-62.52-15.19-107.17-22.33-123.46-.77-1.75-.63-4.33.31-5.77.94-1.43 2.32-1.18 3.09.57 7.46 17.01 24.65 63.64 23.32 128.97-1.16 57-15.61 97.23-24.12 116.14-.43.96-1.05 1.46-1.68 1.46Z"
          className="cls-2tet2"
        />
        <path
          d="M1274.82 332.67v7.44c0-4.13-1.79-7.48-4-7.48h-33.04c-2.21 0-4 3.35-4 7.48v-7.44c0-4.13 1.79-7.48 4-7.48h33.04c2.21 0 4 3.35 4 7.48ZM1274.82 587.02v-7.44c0 4.13-1.79 7.48-4 7.48h-33.04c-2.21 0-4-3.35-4-7.48v7.44c0 4.13 1.79 7.48 4 7.48h33.04c2.21 0 4-3.35 4-7.48Z"
          className="cls-2tet1"
        />
        <path
          d="M1254.63 332.32c-.27 0-.5-.41-.51-.93l-.04-3.78c0-.52.22-.95.5-.97.27-.01.51.4.52.93l.04 3.78c0 .52-.22.95-.5.97h-.01ZM1254.5 320.41c-.27 0-.5-.41-.51-.93l-.09-8.13c0-.52.22-.95.5-.97.28-.02.51.4.52.93l.09 8.13c0 .52-.22.95-.5.97h-.01Zm-.18-16.26c-.27 0-.5-.41-.51-.93l-.09-8.13c0-.52.22-.95.5-.97.28-.01.51.4.52.93l.09 8.13c0 .52-.22.95-.5.97h-.01Zm-.18-16.26c-.27 0-.5-.41-.51-.93l-.09-8.13c0-.52.22-.95.5-.97.27-.02.51.4.52.93l.09 8.13c0 .52-.22.95-.5.97h-.01ZM1253.96 271.64c-.27 0-.5-.41-.51-.93l-.04-3.78c0-.52.22-.95.5-.97h.01c.27 0 .5.41.51.93l.04 3.78c0 .52-.22.95-.5.97h-.01Z"
          className="cls-2tet1"
        />
        <ellipse
          cx={1000.2}
          cy={316.73}
          className="cls-2tet2"
          rx={78.91}
          ry={63.89}
        />
        <path
          d="M921.29 316.73c0-.66.01-1.32.04-1.98-.02.73-.03 1.47-.04 2.21v-.24ZM1079.1 316.73c0 34.59-33.94 62.75-76.33 63.85 16.26-12.58 27.2-36.11 27.2-63.07s-11.93-52.56-29.38-64.67c43.4.17 78.51 28.7 78.51 63.89Z"
          className="cls-2tet1"
        />
        <rect
          width={41.36}
          height={12.08}
          x={979.52}
          y={244.06}
          className="cls-2tet3"
          rx={4.03}
          ry={4.03}
        />
        <rect
          width={41.36}
          height={12.08}
          x={979.52}
          y={377.14}
          className="cls-2tet3"
          rx={4.03}
          ry={4.03}
        />
        <path
          d="M988.83 381.96c-.23 0-.46-.04-.69-.11-14.1-4.65-26.09-13.55-34.68-25.73-8.58-12.17-12.9-26.41-12.5-41.18.39-14.51 5.33-28.3 14.26-39.88 8.94-11.58 21.07-19.88 35.06-23.99 1.17-.34 2.4.33 2.74 1.5a2.21 2.21 0 0 1-1.5 2.74c-26.85 7.89-45.4 31.9-46.16 59.74-.76 28.03 17.39 53.77 44.14 62.6a2.21 2.21 0 0 1-.69 4.31Z"
          className="cls-2tet3"
        />
        <path
          d="M1000.98 384.39c-.63 0-1.26-.27-1.69-.79-8.57-10.19-23.13-31.88-24.3-62.62-1.34-35.23 15.99-60.37 23.5-69.54.77-.94 2.17-1.08 3.11-.31s1.08 2.17.31 3.11c-7.19 8.78-23.79 32.86-22.5 66.57 1.12 29.42 15.06 50.19 23.27 59.95.79.93.67 2.33-.27 3.11-.41.35-.92.52-1.42.52ZM1011.63 381.96a2.21 2.21 0 0 1-.69-4.31c26.75-8.83 44.9-34.57 44.14-62.6-.75-27.85-19.3-51.86-46.16-59.74a2.21 2.21 0 0 1-1.5-2.74 2.21 2.21 0 0 1 2.74-1.5c14 4.11 26.12 12.41 35.06 23.99 8.94 11.58 13.87 25.37 14.26 39.88.4 14.77-3.92 29.01-12.5 41.18-8.58 12.18-20.57 21.08-34.68 25.73-.23.08-.46.11-.69.11Z"
          className="cls-2tet3"
        />
        <path
          d="M999.48 384.39c-.5 0-1.01-.17-1.42-.52a2.215 2.215 0 0 1-.27-3.11c8.21-9.76 22.15-30.53 23.27-59.95 1.28-33.71-15.31-57.79-22.5-66.57-.77-.94-.63-2.34.31-3.11s2.34-.63 3.11.31c7.51 9.17 24.84 34.32 23.5 69.54-1.17 30.74-15.73 52.43-24.3 62.62-.44.52-1.06.79-1.69.79Z"
          className="cls-2tet3"
        />
        <path
          d="M1020.88 248.1v4.01a4.03 4.03 0 0 0-4.03-4.03h-33.29a4.03 4.03 0 0 0-4.03 4.03v-4.01a4.03 4.03 0 0 1 4.03-4.03h33.29a4.03 4.03 0 0 1 4.03 4.03ZM1020.88 385.24v-4.01a4.03 4.03 0 0 1-4.03 4.03h-33.29a4.03 4.03 0 0 1-4.03-4.03v4.01a4.03 4.03 0 0 0 4.03 4.03h33.29a4.03 4.03 0 0 0 4.03-4.03Z"
          className="cls-2tet4"
        />
        <path
          d="M1000.2 250.61a.51.51 0 0 1-.51-.5l-.04-2.04c0-.28.22-.51.5-.52.28 0 .51.22.52.5l.04 2.04c0 .28-.22.51-.5.52h-.01ZM1000.07 244.19a.51.51 0 0 1-.51-.5l-.09-4.38c0-.28.22-.51.5-.52.28 0 .51.22.52.5l.09 4.38c0 .28-.22.51-.5.52h-.01Zm-.18-8.77a.51.51 0 0 1-.51-.5l-.09-4.38c0-.28.22-.51.5-.52.28 0 .51.22.52.5l.09 4.38c0 .28-.22.51-.5.52h-.01Zm-.18-8.77a.51.51 0 0 1-.51-.5l-.09-4.38c0-.28.22-.51.5-.52.27 0 .51.22.52.5l.09 4.38c0 .28-.22.51-.5.52h-.01ZM999.52 217.89a.51.51 0 0 1-.51-.5l-.04-2.04c0-.28.22-.51.5-.52h.01c.28 0 .5.22.51.5l.04 2.04c0 .28-.22.51-.5.52h-.01Z"
          className="cls-2tet3"
        />
        <ellipse
          cx={1528.6}
          cy={422.58}
          className="cls-2tet2"
          rx={103.43}
          ry={83.75}
        />
        <path
          d="M1425.16 422.58c0-.86.02-1.73.05-2.59-.03.96-.04 1.93-.05 2.9v-.31ZM1632.03 422.58c0 45.34-44.5 82.26-100.06 83.7 21.32-16.49 35.66-47.34 35.66-82.68s-15.63-68.9-38.51-84.77c56.89.22 102.91 37.63 102.91 83.74Z"
          className="cls-2tet1"
        />
        <rect
          width={54.22}
          height={15.83}
          x={1501.49}
          y={327.33}
          className="cls-2tet3"
          rx={5.29}
          ry={5.29}
        />
        <rect
          width={54.22}
          height={15.83}
          x={1501.49}
          y={501.77}
          className="cls-2tet3"
          rx={5.29}
          ry={5.29}
        />
        <path
          d="M1513.69 508.08c-.3 0-.61-.05-.91-.15-18.49-6.1-34.2-17.76-45.45-33.73-11.24-15.96-16.91-34.63-16.39-53.99.52-19.02 6.98-37.1 18.7-52.27 11.72-15.18 27.62-26.05 45.96-31.44a2.91 2.91 0 0 1 3.6 1.96c.45 1.54-.43 3.14-1.96 3.6-35.2 10.34-59.51 41.81-60.5 78.32-1 36.74 22.8 70.49 57.86 82.06 1.52.5 2.34 2.14 1.84 3.66a2.89 2.89 0 0 1-2.75 1.99Z"
          className="cls-2tet3"
        />
        <path
          d="M1529.62 511.27c-.83 0-1.65-.35-2.22-1.03-11.24-13.36-30.32-41.8-31.86-82.09-1.76-46.17 20.96-79.13 30.81-91.15a2.902 2.902 0 0 1 4.08-.41 2.902 2.902 0 0 1 .41 4.08c-9.43 11.51-31.18 43.07-29.5 87.26 1.47 38.56 19.74 65.78 30.5 78.58 1.03 1.22.87 3.05-.35 4.08-.54.46-1.2.68-1.86.68ZM1543.59 508.08a2.89 2.89 0 0 1-2.75-1.99c-.5-1.52.32-3.16 1.84-3.66 35.07-11.57 58.86-45.31 57.86-82.06-.99-36.5-25.3-67.98-60.5-78.32a2.894 2.894 0 0 1-1.96-3.6 2.894 2.894 0 0 1 3.6-1.96c18.35 5.39 34.24 16.26 45.96 31.44 11.72 15.18 18.18 33.25 18.7 52.27.52 19.36-5.14 38.03-16.39 53.99s-26.97 27.63-45.45 33.73c-.3.1-.61.15-.91.15Z"
          className="cls-2tet3"
        />
        <path
          d="M1527.66 511.27c-.66 0-1.32-.22-1.86-.68a2.899 2.899 0 0 1-.35-4.08c10.76-12.79 29.03-40.02 30.5-78.58 1.68-44.19-20.07-75.75-29.5-87.26a2.903 2.903 0 0 1 .41-4.08 2.903 2.903 0 0 1 4.08.41c9.85 12.03 32.56 44.98 30.81 91.15-1.53 40.29-20.62 68.72-31.85 82.09-.57.68-1.39 1.03-2.22 1.03Z"
          className="cls-2tet3"
        />
        <path
          d="M1555.7 332.61v5.26c0-2.92-2.37-5.29-5.29-5.29h-43.64c-2.92 0-5.29 2.37-5.29 5.29v-5.26c0-2.92 2.37-5.29 5.29-5.29h43.64c2.92 0 5.29 2.37 5.29 5.29ZM1555.7 512.39v-5.26c0 2.92-2.37 5.29-5.29 5.29h-43.64c-2.92 0-5.29-2.37-5.29-5.29v5.26c0 2.92 2.37 5.29 5.29 5.29h43.64c2.92 0 5.29-2.37 5.29-5.29Z"
          className="cls-2tet4"
        />
        <path
          d="M1528.6 335.91c-.36 0-.66-.29-.67-.65l-.05-2.67c0-.37.29-.67.65-.68.36 0 .67.29.68.65l.05 2.67c0 .37-.29.67-.65.68h-.01ZM1528.42 327.49c-.36 0-.66-.29-.67-.65l-.12-5.75c0-.37.29-.67.65-.68.36-.01.67.29.68.65l.12 5.75c0 .37-.29.67-.65.68h-.01Zm-.24-11.49c-.36 0-.66-.29-.67-.65l-.12-5.75c0-.37.29-.67.65-.68.37 0 .67.29.68.65l.12 5.75c0 .37-.29.67-.65.68h-.01Zm-.24-11.49c-.36 0-.66-.29-.67-.65l-.12-5.75c0-.37.29-.67.65-.68.35-.01.67.29.68.65l.12 5.75c0 .37-.29.67-.65.68h-.01ZM1527.71 293.02c-.36 0-.66-.29-.67-.65l-.05-2.67c0-.37.29-.67.66-.68h.01c.36 0 .66.29.67.65l.05 2.67c0 .37-.29.67-.66.68h-.01Z"
          className="cls-2tet3"
        />
        {children}
      </g>
    </svg>
  );
}
